import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {
    EventType,
    generateMainVisualisationText,
    MainVisualisationEvent,
    MainVisualisationType,
} from '../../../../../models/PartEvent';
import {v4} from 'uuid';

interface OwnProps {
    onSubmit: (partEvent: Omit<MainVisualisationEvent, 'anchor'>) => void;
    onCancel: () => void;
}

export const MainVisualisationStepComponent: FunctionComponent<OwnProps> = ({onSubmit, onCancel}) => {
    const [mainVisualisationType, setMainVisualisationType] = useState<MainVisualisationType>(
        MainVisualisationType.GraphSpeed,
    );

    return (
        <>
            <div className="modal-header">
                <h2>Choose data field</h2>
            </div>
            <div className="modal-body">
                <div className="add-event-wizard">
                    <form>
                        <div className="form-group">
                            <label htmlFor="data-field-type">Data field type</label>
                            <select
                                className="form-control-select"
                                id="data-field-type"
                                name="data-field-type"
                                onChange={(e) => setMainVisualisationType(e.target.value as MainVisualisationType)}
                                value={mainVisualisationType}
                            >
                                {Object.values(MainVisualisationType).map((mv) => (
                                    <option key={mv} value={mv}>
                                        {generateMainVisualisationText(mv)}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </form>
                </div>
            </div>
            <div className="modal-footer">
                <button
                    className="btn btn-secondary pull-right"
                    onClick={() =>
                        onSubmit({
                            __uuid: v4(),
                            type: EventType.MainVisualisation,
                            key: mainVisualisationType,
                        })
                    }
                >
                    Next
                </button>
                <button className="btn btn-secondary pull-right" onClick={onCancel}>
                    Cancel
                </button>
            </div>
        </>
    );
};
